import { useRef } from 'react';
import { telegram } from '../lib/telegram';
import { formatRoll } from '../lib/format';

interface Props {
  target: number;
  onChange: (target: number) => void;
  disabled?: boolean;
  lastRoll: number | null;
  lastWin: boolean;
  popKey: number;
}

// Stake-style дорожка: зелёная зона слева = «бросок меньше target» (выигрыш),
// результат показывается пузырём над дорожкой в точке броска.
export function DiceSlider({ target, onChange, disabled, lastRoll, lastWin, popKey }: Props) {
  const lastInt = useRef(Math.floor(target));
  const pct = Math.max(0, Math.min(100, target));
  const rollPct = lastRoll != null ? Math.max(0, Math.min(100, lastRoll)) : null;

  return (
    <div className="slider">
      {rollPct != null && (
        <div
          key={popKey}
          className={`result-bubble pop ${lastWin ? 'win' : 'lose'}`}
          style={{ left: `${rollPct}%` }}
        >
          {formatRoll(lastRoll!)}
        </div>
      )}
      <div className="track-wrap">
        <div className="track">
          <div className="win-zone" style={{ width: `${pct}%` }} />
        </div>
        <div className="thumb" style={{ left: `${pct}%` }} />
        <input
          type="range"
          min={1}
          max={98}
          step={0.01}
          value={target}
          disabled={disabled}
          onChange={(e) => {
            const v = parseFloat(e.target.value);
            const i = Math.floor(v);
            if (i !== lastInt.current) {
              lastInt.current = i;
              telegram.haptic('soft');
            }
            onChange(v);
          }}
        />
      </div>
      <div className="scale">
        <span>0</span>
        <span>25</span>
        <span>50</span>
        <span>75</span>
        <span>100</span>
      </div>
    </div>
  );
}
